import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-raw-data-display',
  templateUrl: './raw-data-display.component.html',
  styleUrl: './raw-data-display.component.css'
})
export class RawDataDisplayComponent {

	chartSeries;
	results: any[] = [];
	resultsCols: any[] = [];

    constructor(
      public ref: DynamicDialogRef,
      public config: DynamicDialogConfig,
    ) {
        this.chartSeries = this.config.data['chartSeries'];
		this.convertTSToResultsSingle(this.chartSeries);
    }

	// Display the chart data in a single table
	convertTSToResultsSingle(chartSeries) {
		// console.log(chartSeries);
		if ( chartSeries.length == 0 ) {
			console.log("Chart is empty.  No values to display");
			return;
		}

		// 1.  Determine if xAxis is datetime or not
		let datetime = false;
		if ( chartSeries[0].xAxis.dateTime != undefined ) {
			datetime = true;
		}

		//
		// 2. Create the table columns
		//
		if ( datetime ) {
			this.resultsCols.push({ field: "xVal", header: "Time" });
		} else {
			this.resultsCols.push({ field: "xVal", header: "X Value" });
		}

		// loop through reports and create the resultsCols
		chartSeries.forEach ((series: any) => {
			// console.log(series);
			const name = series['userOptions']['name'];
			this.resultsCols.push({ field: name, header: name });
		});


		//
		// 3. Create the table data
		// 
		const uniqueXVals = this.getUniqueXValues(chartSeries);
		// console.log(uniqueXVals);
		uniqueXVals.forEach((currentX: string) => {
			let currentXString = currentX;
			if ( datetime ) {
				let d = new Date(currentX);
				currentXString = d.getFullYear() + "-" + this.toTwoDigitNumber(d.getMonth() + 1) + "-" + this.toTwoDigitNumber(d.getDate()) +
					" " + this.toTwoDigitNumber(d.getHours()) + ":" + this.toTwoDigitNumber(d.getMinutes()) + ":" + this.toTwoDigitNumber(d.getSeconds());
			}
			const newReport: any = { "xVal": currentXString };

			// loop through each data value
			chartSeries.forEach ((series: any) => {
				const data = series.data;
				const dataForX = data.filter((d: any) => {
					return d.x == currentX;
				})

				// a report for the current unique time has been found
				// console.log(dataForX);
				if ( dataForX.length > 0 ) {
					const name = series['userOptions']['name'];
					let yString = "";
					for ( let i=0; i<dataForX.length; i++) {
						if ( i > 0) {
							yString += ", ";
						}
						yString += dataForX[i]['y'];
					}
					newReport[name] = yString;
					this.results.push(newReport);
					// console.log(newReport);
				}
			});
		});
	}

	// Using the data array, create and return an array of the unique x values
	// for all the data set.  Useful when creating a single table.
	getUniqueXValues(chartSeries): any[] {
		const uniqueXVAls: any[] = [];

		// loop through the series for each point
		chartSeries.forEach ((series: any) => {
			// loop through the data to collect the x values
			// console.log(series.data);
			series.data.forEach((entry: any) => {
				const x = entry['x'];
				const existingReportTimeArray = uniqueXVAls.filter((rt: string) => {
					return rt == x;
				})
				if ( existingReportTimeArray.length == 0 ) {
					uniqueXVAls.push(x);
				}
			})
		});

		// now order the x values
		uniqueXVAls.sort();
		return uniqueXVAls;
	}

	toTwoDigitNumber (num:Number):string {
		const formattedNumber = ("0" + num).slice(-2);
		return formattedNumber;
	}
}
